export const IMAGES = {
    hero: "/images/ballroom-reception.jpg",
    about: "/images/emerald-couple.jpg",
};

export const HERO_SLIDES = [
    {
        src: "/images/ballroom-reception.jpg",
        alt: "Ivory-draped ballroom glowing with candles and gold florals",
    },
    {
        src: "/images/rooftop-proposal.jpg",
        alt: "A sunset proposal on a London rooftop — 'Marry Me?' above the Thames",
    },
    {
        src: "/images/celebration-toast.jpg",
        alt: "Champagne toasts and laughter at a candlelit celebration",
    },
    {
        src: "/images/garden-bridesmaids.jpg",
        alt: "The bride and her bridesmaids laughing through a rose garden",
    },
];

export const INSTAGRAM_TILES = [
    "/images/plated-salmon.jpg",
    "/images/place-setting.jpg",
    "/images/canapes.jpg",
    "/images/panna-cotta.jpg",
    "/images/cocktail-pour.jpg",
    "/images/dessert-table.jpg",
];

export const SERVICES = [
    { icon: "Cake", title: "Birthday Planning", blurb: "Milestone moments styled with charm — from intimate dinners to lavish soirées." },
    { icon: "Heart", title: "Weddings", blurb: "Romantic, detail-rich celebrations designed entirely around your love story." },
    { icon: "Gem", title: "Wedding Proposals", blurb: "A breathtaking yes — secret planning, candlelit settings, the perfect question." },
    { icon: "Briefcase", title: "Corporate Events", blurb: "Polished gatherings that reflect your brand with grace, warmth and ease." },
    { icon: "Baby", title: "Baby Showers", blurb: "Soft, joy-filled welcomes for your little one's grand arrival." },
    { icon: "Sparkles", title: "Anniversaries", blurb: "Timeless tributes to the years you have so beautifully built together." },
    { icon: "PartyPopper", title: "Private Parties", blurb: "Exclusive evenings wrapped in candlelight, florals and quiet finesse." },
    { icon: "Flower2", title: "Decorations", blurb: "Bespoke styling — arches, drapery, tablescapes and botanical artistry." },
];

export const PROCESS_STEPS = [
    {
        num: "01",
        title: "Consult",
        text: "We begin with a warm conversation — your story, your dreams, the feeling you want your guests to carry home.",
    },
    {
        num: "02",
        title: "Design",
        text: "A bespoke concept unfolds: palettes, florals, light and texture, sketched around your unique vision.",
    },
    {
        num: "03",
        title: "Curate",
        text: "Every detail is sourced and styled by hand — venues, vendors, tablescapes — refined to perfection.",
    },
    {
        num: "04",
        title: "Celebrate",
        text: "You arrive as a guest at your own event. We orchestrate quietly; you simply live the moment.",
    },
];

export const TESTIMONIALS = [
    {
        quote: "Leemerh turned our wedding into a living fairytale — every candle, every petal was exactly where it was meant to be.",
        name: "Amara & Daniel",
        event: "Wedding, Summer 2025",
    },
    {
        quote: "The room simply glowed. Our guests are still talking about it months later — and so are we.",
        name: "Sophia M.",
        event: "40th Birthday Soirée",
    },
    {
        quote: "From our first consultation to the last dance, everything felt effortless and deeply, wonderfully personal.",
        name: "The Okafor Family",
        event: "Golden Anniversary",
    },
    {
        quote: "My daughter's baby shower looked like a page lifted from a storybook. Pure, gentle magic.",
        name: "Grace T.",
        event: "Baby Shower",
    },
    {
        quote: "Professional, warm, and impossibly creative. Our anniversary dinner was the most beautiful evening of our lives.",
        name: "Elena & Marcus",
        event: "Private Celebration",
    },
];

export const FAQS = [
    {
        q: "Where are you based, and do you travel?",
        a: "We are proudly based in London and design celebrations across the whole of the UK — and yes, we travel. From intimate London townhouses to grand destination weddings, the atelier goes wherever your story takes us.",
    },
    {
        q: "Do you plan traditional Nigerian and fusion weddings?",
        a: "They are close to our heart. We weave traditional ceremonies — the colours, the aso-ebi, the talking drum, the joy — together with classic white-wedding elegance, so both sides of your story are honoured beautifully in one seamless celebration.",
    },
    {
        q: "Can you arrange African catering and cultural vendors?",
        a: "Absolutely. We work with a trusted circle of caterers and creatives — from proper hot jollof, suya and small chops to drummers, MCs and traditional decorators — so every flavour and every moment feels authentically yours.",
    },
    {
        q: "How far in advance should we book?",
        a: "For weddings, nine to twelve months gives us the most room to craft something extraordinary — though we have woven magic in far less. Proposals and intimate celebrations typically need four to six weeks. Whenever you are ready, write to us and we will be honest about what is possible.",
    },
    {
        q: "What do your packages and pricing look like?",
        a: "No two celebrations are alike, so neither are our proposals. After a relaxed consultation we prepare a tailored proposal around your vision and budget — whether that is full planning from first sketch to final dance, partial planning, or day-of coordination alone.",
    },
    {
        q: "Will you be there on the day itself?",
        a: "Always. On the day, our team is quietly everywhere — steering vendors, perfecting details, calming nerves — so you and the people you love are free to simply live the moment.",
    },
];

export const CONTACT = {
    email: "eventsbyleemerh@outlook.com",
    phone: "07983 883039",
    instagram: "@Eventsbyleemerh",
    instagramUrl: "https://instagram.com/Eventsbyleemerh",
};
